module.exports = {
      id: "comm-album-usage",
      viewBox: "0 0 230.223 54.026",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-album",
      toString: function () {
        return this.url;
      }
    }